import { pickIntent } from "./helpers/ui.js";
import './assets/constants.css';const tray = "_tray_b12z5_1";
const vertical = "_vertical_b12z5_10";
const toast = "_toast_b12z5_18";
const horizontal = "_horizontal_b12z5_21";
const secondary = "_secondary_b12z5_53";
const critical = "_critical_b12z5_57";
const warning = "_warning_b12z5_72";
const success = "_success_b12z5_87";
const info = "_info_b12z5_102";
const container = "_container_b12z5_117";
const icon = "_icon_b12z5_126";
const content = "_content_b12z5_132";
const header = "_header_b12z5_141";
const message = "_message_b12z5_152";
const footerContainer = "_footerContainer_b12z5_164";
const s = {
  tray,
  vertical,
  toast,
  horizontal,
  secondary,
  critical,
  warning,
  success,
  info,
  container,
  icon,
  content,
  header,
  message,
  footerContainer
};
const TOAST_TYPE = {
  VERTICAL: "vertical",
  HORIZONTAL: "horizontal"
};
const TOAST_INTENT = pickIntent(["secondary", "critical", "warning", "success", "info"]);
const TOAST_INTENT_CLASSNAME_MAP = {
  [TOAST_INTENT.SECONDARY]: s.secondary,
  [TOAST_INTENT.CRITICAL]: s.critical,
  [TOAST_INTENT.WARNING]: s.warning,
  [TOAST_INTENT.SUCCESS]: s.success,
  [TOAST_INTENT.INFO]: s.info
};
const TOAST_TYPE_CLASSNAME_MAP = {
  [TOAST_TYPE.VERTICAL]: s.vertical,
  [TOAST_TYPE.HORIZONTAL]: s.horizontal
};
export {
  TOAST_TYPE as T,
  TOAST_INTENT as a,
  TOAST_INTENT_CLASSNAME_MAP as b,
  TOAST_TYPE_CLASSNAME_MAP as c,
  s
};
